<div extendSlot="hello-world" (event)="debugEvent($event)"></div>

<div extendSlot="hello-world" [dataObservable]="data.name$"></div>

<div extendSlot="hello-world" [dataObservable]="data.foo$"></div>
